var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useSearchParams } from 'react-router-dom';
import { has } from 'lodash';
import { ErrorFallback } from "./ErrorFallback";

import Footer from "../Footer";
import { searchParamsFromSearchParams } from "../../utils/routeHelpers";
import { t } from "../../I18N";

const handledErrors = {
  400: {
    title: 'Bad Request',
    summary: 'Bad Request',
    name: 'The request could not be processed.',
    message: '',
    code: '400'
  },
  404: {
    title: 'Not Found',
    summary: '',
    name: "We can't find the page you're looking for.",
    message: '',
    code: '404'
  },
  500: {
    title: 'Unexpected error',
    summary: 'Unexpected error',
    name: '',
    message: '',
    code: '500'
  }
};

const GeneralError = () => {
  const { errorCode } = useParams();
  const [searchParams] = useSearchParams();

  const { requestId } = searchParamsFromSearchParams(searchParams);
  const { code } =
  errorCode && has(handledErrors, errorCode) ? handledErrors[errorCode] : handledErrors[404];
  const safeRequestId = /^[0-9-]{4}$/.exec(requestId);
  const error = handledErrors[code];
  error.requestId = safeRequestId ? safeRequestId[0] : undefined;
  const errorTitle = t('System', error.title, null, false);
  return /*#__PURE__*/(
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(Helmet, {}, void 0, /*#__PURE__*/
    _jsx("title", {}, void 0, errorTitle)
    ), /*#__PURE__*/
    _jsx(ErrorFallback, { error: error }), /*#__PURE__*/
    _jsx(Footer, {})
    ));

};

export default GeneralError;